module.exports = __webpack_public_path__ + "img/about7.6fb227da.jpg";